import { List } from "immutable";
import _ from "lodash";
import React from "react";
import * as BS from "react-bootstrap";
import * as RS from "react-sortable-hoc";
import { ContentBlockEditorProps } from "./";
import * as Comp from "../../../../components";
import { NavigationTypes } from "../../../../domain";
import { ContentBlockTypes } from "../../../../domain/ContentBlockTypes";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Utility } from "../../../../utils";

type OwnProps = ContentBlockEditorProps & {
    links: Forms.AdminPage.ContentLinkData[];
    navItems: List<M.AdminNav.NavListItem>;
    promptThumbnail: boolean;
};

interface OwnState {
    showSequencer: boolean;
}

export const ContentLinkList_DefaultLink: Forms.AdminPage.ContentLinkData = {
    deleted: false,
    id: 0,
    index: 0,
    linkType: Forms.AdminPage.LINK_TYPE_PAGE,
    promptThumbnail: false,
    sort: 1,
    thumbnailType: Forms.AdminPage.THUMBNAIL_TYPE_IMAGE,
    title: "",
};

export type ContentLinkListMoveDir = -1 | 0 | 1 | 2;

export class ContentLinkListEditor extends React.Component<OwnProps, OwnState> {

    private _linkTypes: M.Editors.SelectItem[] = [
        { id: 0, render: "Page", selected: false },
        { id: 1, render: "URL", selected: false },
    ];

    private _thumbnailTypes: M.Editors.SelectItem[] = [
        { id: 0, render: "Image", selected: false },
        { id: 1, render: "Icon", selected: false },
    ];

    public constructor(props: any) {
        super(props);
        this.state = {
            showSequencer: false,
        };
    }

    public render() {
        const label = this.props.label
            ? <Comp.Editors.FormField name=""><hr /><h2>{this.props.label}</h2></Comp.Editors.FormField>
            : null;

        // Build link editors
        const sortedLinks = _.orderBy(this.props.links, "sort");
        const links = sortedLinks.map((lnk, i) => {
            const linkTypes: M.Editors.SelectItem[] = this._linkTypes.map((t) => {
                return {
                    ...t,
                    selected: lnk.linkType === t.id,
                };
            });

            const thmbTypes: M.Editors.SelectItem[] = this._thumbnailTypes.map((t) => {
                return {
                    ...t,
                    selected: lnk.thumbnailType === t.id,
                };
            });

            const thumbEditor = lnk.thumbnailType === Forms.AdminPage.THUMBNAIL_TYPE_ICON
                ? <Comp.Editors.TextField
                    formComponent={this.props.formComponent}
                    name={this.props.namePrefix + `links[${i}].icon`}
                    noFieldWrap
                    placeholder="Select an icon"
                    required={false}
                />
                : <Comp.Editors.TextField
                    formComponent={this.props.formComponent}
                    name={this.props.namePrefix + `links[${i}].iconImage`}
                    noFieldWrap
                    placeholder="Select an image"
                    required={false}
                />;

            // thumbnail wrapper, whether to display or not depends on
            // value of content block promptThumbnail field
            const thumbWrapper = this.props.promptThumbnail
                ? <Comp.Editors.FormField label="Thumbnail" name="" required>
                    <Comp.Editors.RadioOrCheckListField
                        formComponent={this.props.formComponent}
                        items={thmbTypes}
                        listCss="options-h"
                        name={this.props.namePrefix + `links[${i}].thumbnailType`}
                        noFieldWrap
                        type="radio"
                    />

                    {thumbEditor}
                </Comp.Editors.FormField>
                : null;

            const urlEditor = lnk.linkType === Forms.AdminPage.LINK_TYPE_URL
                ? <Comp.Editors.TextField
                    formComponent={this.props.formComponent}
                    css="txt"
                    name={this.props.namePrefix + `links[${i}].linksToUrl`}
                    noFieldWrap
                    placeholder="http[s]://... for external URLs, or #... for internal jump-to links"
                    required={false}
                />
                : <Comp.Editors.SelectField
                    formComponent={this.props.formComponent}
                    isAsync
                    name={this.props.namePrefix + `links[${i}].linksToNav`}
                    noFieldWrap
                    // onInputChange={(inputName, value) => this.onParentChange(value)}
                    select={{
                        cache: false,
                        loadOptions: (search: string) => this.searchNavItems(search),
                        optionRenderer: (n: M.AdminNav.NavListItem) => <span>{n.title}<br /><span className="mute">{n.fullTitle}</span></span>,
                    }}
                />;

            return <li key={i} className="list-builder-item" style={{ display: lnk.deleted ? "none" : "block" }}>
                <div className="list-builder-fields">
                    {thumbWrapper}

                    <Comp.Editors.FormField label="Links to" name="" required>
                        <Comp.Editors.RadioOrCheckListField
                            formComponent={this.props.formComponent}
                            items={linkTypes}
                            listCss="options-h"
                            name={this.props.namePrefix + `links[${i}].linkType`}
                            noFieldWrap
                            type="radio"
                        />

                        {urlEditor}
                    </Comp.Editors.FormField>

                    <Comp.Editors.TextField
                        formComponent={this.props.formComponent}
                        css="txt"
                        name={this.props.namePrefix + `links[${i}].title`}
                        required
                    />
                </div>
                <BS.Button bsStyle="danger" className="remove-trigger" onClick={() => this.onLinkDelete(lnk.index)} title="Delete link"><i className="fa fa-times"></i></BS.Button>
            </li>;
        });

        // Build sortable component for separately sorting links
        const SortableItem = RS.SortableElement((lnk: Forms.AdminPage.ContentLinkData) => {
            return <li className="list-group-item" style={{ display: lnk.deleted ? "none" : "block" }}>
                {lnk.title || "Untitled"}
            </li>;
        });

        const SortableList = RS.SortableContainer((items: { children: Forms.AdminPage.ContentLinkData[] }) => {
            return <ul className="list-group">
                    {items.children.map((c, i) => <SortableItem {...c} key={i} index={i} />)}
                </ul>;
        });

        const visibleItems = this.props.links.filter((lnk) => !lnk.deleted).length;

        const sortable = visibleItems > 1 && this.state.showSequencer
            ? <Comp.Editors.FormField name="">
                <p>Drag and drop individual links to desired order</p>
                <SortableList children={this.props.links} onSortEnd={(sort, evt) => this.onSortEnd(sort, evt)} />
            </Comp.Editors.FormField>
            : null;

        const sortToggleBtn = visibleItems > 1
            ? <BS.Button onClick={() => this.toggleSequencer()}>Sort links <i className="fa fa-caret-down"></i></BS.Button>
            : null;

        return <div className="content-block-editor">
            {label}

            <Comp.Editors.FormField label="Links" name="">
                <ul className="list-builder">
                    {links}
                </ul>
            </Comp.Editors.FormField>

            <Comp.Editors.FormField name="">
                <BS.ButtonGroup>
                    <BS.Button onClick={() => this.onLinkAdd()}><i className="fa fa-plus"></i> Add link</BS.Button>
                    {sortToggleBtn}
                </BS.ButtonGroup>
            </Comp.Editors.FormField>

            {sortable}
        </div>;
    }

    private onLinkAdd() {
        const formModel = this.props.formComponent.getFormModel<Forms.AdminPage.PageEditData>();
        const list = _.find(formModel.data.contentBlocks,
            (cb) => (cb.index === this.props.contentBlockIndex && cb.typeId === ContentBlockTypes.LinkList.id)) as Forms.AdminPage.ContentLinkListData;

        if (list) {
            list.links.push({
                ...ContentLinkList_DefaultLink,
                index: list.links.length,
                promptThumbnail: this.props.promptThumbnail,
                sort: (_.max(list.links.map((s) => s.sort)) || 0) + 1,
            });
            this.props.formComponent.updateFormModel(formModel);
        }
    }

    private onLinkDelete(slideIdx: number) {
        const formModel = this.props.formComponent.getFormModel<Forms.AdminPage.PageEditData>();
        const list = _.find(formModel.data.contentBlocks,
            (cb) => (cb.index === this.props.contentBlockIndex && cb.typeId === ContentBlockTypes.LinkList.id)) as Forms.AdminPage.ContentLinkListData;

        if (list) {
            const link = _.find(list.links, (s, i) => s.index === slideIdx);
            if (link)
                link.deleted = true;
            this.props.formComponent.updateFormModel(formModel);
        }
    }

    private onSortEnd(sort: RS.SortEnd, event: RS.SortEvent) {
        const formModel = this.props.formComponent.getFormModel<Forms.AdminPage.PageEditData>();
        const list = _.find(formModel.data.contentBlocks,
            (cb) => (cb.index === this.props.contentBlockIndex && cb.typeId === ContentBlockTypes.LinkList.id)) as Forms.AdminPage.ContentLinkListData;

        if (list) {
            const sortedLinks = _.orderBy(list.links, "sort");
            list.links = RS.arrayMove(sortedLinks, sort.oldIndex, sort.newIndex).map((lnk, i) => {
                lnk.sort = i + 1;
                return lnk;
            });
            this.props.formComponent.updateFormModel(formModel);
        }
    }

    private searchNavItems(search: string) {
        if (!search || search.length < 2)
            return Promise.resolve({ options: [] });

        const navItems = this.props.navItems.toArray()
            .filter((n) => {
                return n.title.toLowerCase().indexOf(search.toLowerCase()) > -1
                    && NavigationTypes.isContentType(n.typeId); // must include only nav items that can have children
            })
            .map((n) => (Utility.toReactSelectOption(n, n.title, n.id)));

        const scoredItems = Utility.sortFilteredArrayByRelevance(navItems, (n) => n.title, search, ["title"]);

        return new Promise((resolve, reject) => {
            resolve({
                options: scoredItems,
            });
        });
    }

    private toggleSequencer() {
        this.setState({ ...this.state, showSequencer: !this.state.showSequencer });
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminPage/edit/editors/ContentLinkListEditor.tsx